module.exports = __webpack_public_path__ + "static/countdown-flower-f84b351ec6c2538a6b1353bd1bb18d55.png";